import { Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import { CustomerComplianceDocument } from '@texas/api/endpoints/customersApi';
import {
  ArticleCertificateBranch,
  UpdateArticleCertificatesRequest,
} from '@texas/api/endpoints/articlesApi';
import { BranchRegion } from '@texas/api/endpoints/branchRegionsApi';
import { ComplianceDocumentDefinition } from '@texas/api/endpoints/metadata/complianceDocumentDefinitionsApi';
import { articleCertificateStyles as styles } from '@texas/resources/theme/styles/entityWorkspace';
import { Control, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ArticleBranchCertificates } from './ArticleBranchCertificates';

interface Props {
  branches: ArticleCertificateBranch[];
  allBranches: ArticleCertificateBranch[];
  regions: BranchRegion[];
  definitions: ComplianceDocumentDefinition[];
  customerRequirements: CustomerComplianceDocument[];
  control: Control<UpdateArticleCertificatesRequest>;
  isDisabled: boolean;
}

export function ArticleCertificatesTable({
  branches,
  allBranches,
  regions,
  definitions,
  customerRequirements,
  control,
  isDisabled,
}: Props) {
  const { t } = useTranslation();
  return (
    <Table sx={styles.table}>
      <Thead>
        <Tr>
          <Th>{t('general.name')}</Th>
          <Th>{t('configuration.identifier')}</Th>
          <Th>{t('article.create.region')}</Th>
          <Th>{t('article.create.certificateLabel')}</Th>
        </Tr>
      </Thead>
      <Tbody>
        {branches.map((branch) => (
          <Tr key={branch.branchId}>
            <Td>{branch.name}</Td>
            <Td>{branch.identifier}</Td>
            <Td>
              {regions
                .filter((region) =>
                  region.branches.some((item) => item.id === branch.branchId),
                )
                .map((region) => region.name)
                .join(', ') || t('general.none')}
            </Td>
            <Td>
              <Controller
                control={control}
                defaultValue={branch.certificateDefinitionIds}
                name={`branches.${allBranches.findIndex(
                  (item) => item.branchId === branch.branchId,
                )}.certificateDefinitionIds`}
                render={({ field }) => (
                  <ArticleBranchCertificates
                    branch={branch}
                    definitions={definitions}
                    customerRequirements={customerRequirements}
                    value={field.value}
                    onChange={field.onChange}
                    isDisabled={isDisabled}
                  />
                )}
              />
            </Td>
          </Tr>
        ))}
        {!branches.length && (
          <Tr>
            <Td colSpan={4}>
              {t(
                allBranches.length
                  ? 'article.management.noMatchingBranches'
                  : 'article.management.noConnectedBranches',
              )}
            </Td>
          </Tr>
        )}
      </Tbody>
    </Table>
  );
}
